<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label">Menu:</label>
                </div>
                <div class="col-auto">
                    <select @change="ListarNotificacionesDetalle" v-model="IdNotificacionConfig" class="form-select form-control-search">
                        <option value="">Selecciona una Opción</option>
                        <option v-for="(item,ind) in ListaNotificacionesConfig" :key="ind" :value="item.IdNotificacionConfig">{{item.Menu}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label v-show="MostrarLabel" class="col-form-label">Aún no ha guardado la selección</label>
                </div>
            </template>
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormNotificacionUsuario" role="form" method="post" autocomplete="off" onSubmit="return false">
                            <div class="form-row row mt-4">
                                <div v-for="(item,index) in ListaNotificacionesDetalle" :key="index" class="col-lg-12">
                                    <div class="form-check">
                                        <input @change="ComparaLista()" class="form-check-input" type="checkbox" v-model="ListaNotificaciones" :value="item.IdNotificacionConfigDetalle" :id="index">
                                        <label class="form-check-label" :for="index">
                                            {{ item.Descripcion }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-12">
                                    <CBtnSave :poBtnSave="oBtnSave" />
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
    </div>
</template>

<script>
const EmitEjecuta='seccionAsignarNotificaciones';
export default {
    name:'FormAsignarNotificaciones',
    props:["IdUsuario"],
    data() {
        return {
            ConfigList:{
                Title: 'Asignar Notificación',
				ShowTitleFirst: false,
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: true,
                ShowSearch:false,
                ShowPaginador: false,
                ShowEntradas: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            oBtnSave:{
                toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'empleados',
                EmitSeccion: EmitEjecuta,
            },
            Emit:EmitEjecuta,
            segurity:{},
            IdNotificacionConfig:"",
            ListaNotificaciones:[],
            ListaNotificacionesCopia:[],
            ListaNotificacionesDetalle:[],
            ListaNotificacionesConfig:[],
            IdUsuarioD:0,
            MostrarLabel:false
        }
    },
    methods: {
        async Guardar()
        {
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;

            let formData=new FormData();
            formData.append('ListaNotificaciones',JSON.stringify(this.ListaNotificaciones));
            formData.set('IdUsuario',this.IdUsuarioD);
            await this.$http.post('notificacionesConfigDetallexUsuario',formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Regresar(){
            this.$router.push({name:'empleados',params:{}});
        },
        ListarNotificacionesDetalle(){
            this.ConfigLoad.ShowLoader=true;
            this.ConfigList.ShowLoader=true;
            this.$http.get('notificacionesConfigDetalleSimple',{
                params:{
                    IdNotificacionConfig:this.IdNotificacionConfig
                }
            }).then((res)=>{
                this.ListaNotificacionesDetalle=res.data.data;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
                this.ConfigList.ShowLoader=false;
            })
        },
        ListarNotificacionesxUsuario(){
            // this.ListaNotificacionesCopia=this.ListaNotificaciones;
            this.$http.get('notificacionesConfigDetallexUsuario/'+this.IdUsuarioD
            ).then((res)=>{
                this.ListaNotificaciones=res.data.data.map((element)=>element.IdNotificacionConfigDetalle);
                this.ListaNotificacionesCopia=res.data.data.map((element)=>element.IdNotificacionConfigDetalle);
            })
        },
        ListarMenus(){
            this.$http.get('notificacionesConfigSimple'
            ).then((res)=>{
                this.ListaNotificacionesConfig=res.data.data;
                this.IdNotificacionConfig=this.ListaNotificacionesConfig[0].IdNotificacionConfig;
                this.ListarNotificacionesDetalle();
            });
        },
        ComparaLista(){
            if (this.ListaNotificaciones.sort().join(',')!==this.ListaNotificacionesCopia.sort().join(',')) {
                this.MostrarLabel=true;
            }
            else{
                this.MostrarLabel=false;
            }
        }
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;
        if (this.IdUsuario!=undefined) {
            sessionStorage.setItem("IdUsuario",this.IdUsuario);
        }

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted() {
        this.IdUsuarioD=sessionStorage.getItem("IdUsuario");
        this.oBtnSave.DisableBtn = false;
        this.ListarMenus();
        this.ListarNotificacionesxUsuario();

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>